export default {
  color: '#1976d2',
  failedColor: '#ff5252',
  thickness: '4px',
};



// WEBPACK FOOTER //
// ./src/plugins/options/progressBar.js